import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * PricingPage - Redirects to the unified Upgrade page
 * All payments are now handled via Razorpay on /upgrade
 */
const PricingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to upgrade page which has Razorpay integration
    navigate("/upgrade", { replace: true });
  }, [navigate]);

  return null;
};

export default PricingPage;
